import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader, DecodeHintType } from "@zxing/library";

import Backdrop from "@mui/material/Backdrop";

type Props = {
  onScan: (result: string) => void;
  onClose: () => void;
};

export const BarcodeReader: React.FC<Props> = ({ onScan, onClose }) => {
  const [codeReader, setReader] = useState<BrowserMultiFormatReader | null>(
    new BrowserMultiFormatReader()
  );
  const [isOn, setIsOn] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const startScanner = async () => {
      setIsOn(true);
      const hints = new Map<DecodeHintType, any>();
      hints.set(DecodeHintType.TRY_HARDER, true);

      try {
        const mediaDevices = navigator.mediaDevices as any;
        const stream = await mediaDevices.getUserMedia({ video: true });
        videoRef.current!.srcObject = stream;
        codeReader?.decodeFromVideoDevice(
          null,
          videoRef.current!,
          (result: any, error: any) => {
            if (result) {
              onScan(result.getText());
              codeReader.reset();
            }
          }
        );
      } catch (error) {
        console.error(error);
      }
    };
    startScanner();
  }, [codeReader]);

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isOn}
        onClick={() => {
          codeReader?.reset();
          onClose();
          setIsOn(false);
        }}
      >
        <video ref={videoRef} style={{ width: "100%", height: "auto" }} />
      </Backdrop>

      {/* <Button
        variant="outlined"
        color="inherit"
        sx={{
          mx: "5px",
        }}
        onClick={startScanner}
      >
        <QrCodeIcon />
      </Button> */}
    </>
  );
};
